import React from "react";
import Skeleton from "./Skeleton";

const ProjectCardSkeleton = () => (
  <div className="projectCard" style={{ pointerEvents: "none" }}>
    <Skeleton variant="card" width={44} height={44} borderRadius={8} />
    <div className="pcInfo">
      <Skeleton width="120px" height={14} style={{ marginBottom: 8 }} />
      <Skeleton width="100%" height={11} />
    </div>
    <div className="pcStatus" style={{ gap: 8 }}>
      <Skeleton width={90} height={22} borderRadius={20} />
      <Skeleton width="100%" height={30} borderRadius={6} />
    </div>
  </div>
);

export default ProjectCardSkeleton;
